import {
	FETCH_COUNTRIES,
	SELECT_COUNTRY,
	FETCH_LEVEL2_ENTITIES,
	EMPTY_LEVEL2_ENTITIES,
	SELECT_LEVEL_2,
	FETCH_LEVEL3_ENTITIES,
	EMPTY_LEVEL3_ENTITIES,
	SELECT_LEVEL_3
} from '@/redux/actions/geo.actions'

const initialState = {
	error: false,
	loading: false,
	countries: { byGeonameId: {}, allGeonameIds: [] },
	selectedCountry: null,
	level2: {
		loading: false,
		countryGeonameId: null,
		matchingTerm: null,
		matchesByGeonameId: {},
		allMatchesGeonameIds: []
	},
	selectedLevel2: null,
	level3: {
		loading: false,
		level2GeonameId: null,
		matchingTerm: null,
		matchesByGeonameId: {},
		allMatchesGeonameIds: []
	},
	selectedLevel3: null
}

const countries = (state = initialState.countries, action) => {
	switch (action.type) {
		case FETCH_COUNTRIES.REQUEST:
		case FETCH_COUNTRIES.FAILURE:
			return { byGeonameId: {}, allGeonameIds: [] }
		case FETCH_COUNTRIES.SUCCESS:
			return action.payload.reduce(
				(acc, country) => ({
					byGeonameId: {
						...acc.byGeonameId,
						[country.geonameId]: country
					},
					allGeonameIds: [...acc.allGeonameIds, country.geonameId]
				}),
				{ matchesByGeonameId: {}, allGeonameIds: [] }
			)
		default:
			return state
	}
}

const selectedCountry = (state = initialState.selectedCountry, action) => {
	switch (action.type) {
		case SELECT_COUNTRY:
			return action.payload
		default:
			return state
	}
}

const level2 = (state = initialState.level2, action) => {
	switch (action.type) {
		case FETCH_LEVEL2_ENTITIES.SUCCESS:
			return {
				countryGeonameId: action.payload.countryGeonameId,
				matchingTerm: action.payload.searchTerm,
				loading: false,
				...action.payload.entities.reduce(
					(acc, entity) => ({
						matchesByGeonameId: {
							...acc.matchesByGeonameId,
							[entity.geonameId]: entity
						},
						allMatchesGeonameIds: [...acc.allMatchesGeonameIds, entity.geonameId]
					}),
					{ matchesByGeonameId: {}, allMatchesGeonameIds: [] }
				)
			}
		case FETCH_LEVEL2_ENTITIES.REQUEST:
			return {
				loading: true,
				countryGeonameId: null,
				matchingTerm: action.searchTerm,
				matchesByGeonameId: {},
				allMatchesGeonameIds: []
			}
		case FETCH_LEVEL2_ENTITIES.FAILURE:
		case EMPTY_LEVEL2_ENTITIES:
			return {
				loading: false,
				countryGeonameId: null,
				matchingTerm: null,
				matchesByGeonameId: {},
				allMatchesGeonameIds: []
			}
		default:
			return state
	}
}

const selectedLevel2 = (state = initialState.selectedLevel2, action) => {
	switch (action.type) {
		case SELECT_LEVEL_2:
			return action.payload
		default:
			return state
	}
}

const level3 = (state = initialState.level3, action) => {
	switch (action.type) {
		case `${FETCH_LEVEL3_ENTITIES}_SUCCESS`:
			return {
				level2GeonameId: action.payload.level2GeonameId,
				matchingTerm: action.searchTerm,
				loading: false,
				...action.payload.entities.reduce(
					(acc, entity) => ({
						matchesByGeonameId: {
							...acc.matchesByGeonameId,
							[entity.geonameId]: entity
						},
						allMatchesGeonameIds: [...acc.allMatchesGeonameIds, entity.geonameId]
					}),
					{ matchesByGeonameId: {}, allMatchesGeonameIds: [] }
				)
			}
		case `${FETCH_LEVEL3_ENTITIES}_REQUEST`:
			return {
				loading: true,
				countryGeonameId: null,
				matchingTerm: action.searchTerm,
				matchesByGeonameId: {},
				allMatchesGeonameIds: []
			}
		case `${FETCH_LEVEL3_ENTITIES}_FAILURE`:
		case EMPTY_LEVEL3_ENTITIES:
			return {
				loading: false,
				countryGeonameId: null,
				matchingTerm: null,
				matchesByGeonameId: {},
				allMatchesGeonameIds: []
			}
		default:
			return state
	}
}

const selectedLevel3 = (state = initialState.selectedLevel3, action) => {
	switch (action.type) {
		case SELECT_LEVEL_3:
			return action.payload
		default:
			return state
	}
}

const error = (state = initialState.error, action) => {
	switch (action.type) {
		case FETCH_COUNTRIES.REQUEST:
		case FETCH_COUNTRIES.SUCCESS:
		case FETCH_LEVEL2_ENTITIES.REQUEST:
		case FETCH_LEVEL2_ENTITIES.SUCCESS:
		case `${FETCH_LEVEL3_ENTITIES}_REQUEST`:
		case `${FETCH_LEVEL3_ENTITIES}_SUCCESS`:
			return false
		case FETCH_COUNTRIES.FAILURE:
		case FETCH_LEVEL2_ENTITIES.FAILURE:
		case `${FETCH_LEVEL3_ENTITIES}_FAILURE`:
			return true
		default:
			return state
	}
}

const loading = (state = initialState.loading, action) => {
	switch (action.type) {
		case FETCH_COUNTRIES.REQUEST:
		case FETCH_LEVEL2_ENTITIES.REQUEST:
		case `${FETCH_LEVEL3_ENTITIES}_REQUEST`:
			return true
		case FETCH_COUNTRIES.SUCCESS:
		case FETCH_COUNTRIES.FAILURE:
		case FETCH_LEVEL2_ENTITIES.SUCCESS:
		case FETCH_LEVEL2_ENTITIES.FAILURE:
		case `${FETCH_LEVEL3_ENTITIES}_SUCCESS`:
		case `${FETCH_LEVEL3_ENTITIES}_FAILURE`:
			return false
		default:
			return state
	}
}

export default {
	name: 'geo',
	reducers: {
		countries,
		selectedCountry,
		level2,
		selectedLevel2,
		level3,
		selectedLevel3,
		error,
		loading
	}
}
